module.exports = __webpack_public_path__ + "static/media/placeholder-loading.c4f82637.gif";